"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SeoManagerHelpers = require("../helpers/SeoManagerHelpers");

var _utils = require("../helpers/utils");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ENCODE_EXCLUDE_PARAMS = ['seo_manager_type', 'geo', 'locations', 'bedrooms', 'rooms', 'seo_decode_type', 'isMap'];

var BaseSeoManagerEncoder = /*#__PURE__*/function () {
  function BaseSeoManagerEncoder(domain, lang, supported_lang_slug) {
    _classCallCheck(this, BaseSeoManagerEncoder);

    this.domain = domain;
    this.lang = lang;
    this.supported_lang_slug = supported_lang_slug;
    this.data = {};
    this.num_levels = 0;
    this.immotype = undefined;
    this.encode_parts = {};
    this.encode_qs = [];
  }

  _createClass(BaseSeoManagerEncoder, [{
    key: "getTREncode",
    value: function getTREncode() {
      return _SeoManagerHelpers.TR_ENCODE;
    }
  }, {
    key: "getEncode",
    value: function getEncode() {
      return _SeoManagerHelpers.RE_ENCODE;
    }
  }, {
    key: "getCATEncode",
    value: function getCATEncode(category) {
      try {
        return _SeoManagerHelpers.CAT_ENCODE[this.lang][category];
      } catch (error) {
        return category;
      }
    }
  }, {
    key: "isPTYPEEncodeToExclude",
    value: function isPTYPEEncodeToExclude(category, ptype) {
      try {
        if (_SeoManagerHelpers.PROPERTY_TYPES_TO_EXCLUDE_FROM_SEO_URL[this.lang][category] && _SeoManagerHelpers.PROPERTY_TYPES_TO_EXCLUDE_FROM_SEO_URL[this.lang][category].includes(ptype)) {
          return true;
        }

        return false;
      } catch (error) {
        return false;
      }
    }
  }, {
    key: "hasChildOfNonAdminZone",
    value: function hasChildOfNonAdminZone(locations) {
      if (locations && locations.length > 0) {
        return locations.some(function (location) {
          return location.level === 132;
        });
      }
    }
  }, {
    key: "encodeSrpUrl",
    value: function encodeSrpUrl(params, locations) {
      var _this = this;

      var q = [];
      var ft = [];
      var postalcode = [];
      params = (0, _SeoManagerHelpers.checkParamsFromMyCasa)(params);
      var qs = Object.assign({}, params);
      delete qs.is301Torino;

      if (locations) {
        locations.map(function (l) {
          if (l.type === 'freetext' && l.name) {
            ft.push(encodeURIComponent(l.name));
          } else if ((l.type === 'postalcode' || l.type === 'postal_code') && l.name) {
            postalcode.push(encodeURIComponent(l.name));
          } else if (l.hkey) {
            q.push(l.hkey);
          }
        });
        delete qs.locations;
      }

      if (q.length) {
        qs.q = "".concat(q.join(','));
      }

      if (ft.length) {
        qs.ft = "".concat(ft.join('@'));
      }

      if (postalcode.length) {
        qs.postalcode = "".concat(postalcode.join(','));
      }

      if (qs.nonAdminPrefix) {
        delete qs.nonAdminPrefix;
      }

      if (params.propertyTypes) {
        var pTypesSlugs = [];

        if (!Array.isArray(params.propertyTypes) && typeof params.propertyTypes === 'string') {
          params.propertyTypes = params.propertyTypes.split(',');
        } else if (!Array.isArray(params.propertyTypes) && _typeof(params.propertyTypes) === 'object') {
          params.propertyTypes = [params.propertyTypes.slug];
        }

        params.propertyTypes.map(function (ptype) {
          pTypesSlugs.push((0, _SeoManagerHelpers.getChildrenImmotypeSlugFromKeys)(params.category || params.propertyTypeGroup, ptype, _this.lang, null, {
            forceSrpUrl: true
          }) || ptype);
        });
        qs.propertyTypes = pTypesSlugs;
      }
      /* TECH-7860 - TRASPASOS */


      if (params.license_type_groups) {
        var license_type_groupsSlugs = [];

        if (!Array.isArray(params.license_type_groups) && typeof params.license_type_groups === 'string') {
          params.license_type_groups = params.license_type_groups.split(',');
        }

        params.license_type_groups.map(function (license_type_groupsItem) {
          return license_type_groupsSlugs.push((0, _SeoManagerHelpers.getLicenseTypeGroupSlugFromKey)(license_type_groupsItem, _this.lang, false) || license_type_groupsItem);
        });
        qs.license_type_groups = license_type_groupsSlugs;
      }
      /* TECH-7860 - TRASPASOS */


      var isMap = 'isMap' in params && params.isMap; // if (isMap) {
      //   if (!('precision' in qs) || !qs.precision) {
      //     let maxLevel = 4;
      //     let defaultZoom = 4;
      //     if(locations && locations.length) {
      //       locations.map((el) => { if (el.level > maxLevel) { maxLevel = el.level; } });
      //       const precisionFromLevel = {
      //         4: 4,
      //         6: 5,
      //         9: 6,
      //         10: 7,
      //         118: 6,
      //         120: 11,
      //       }
      //       qs.precision = precisionFromLevel[maxLevel] || maxLevel;
      //     } else {
      //       const { geocircle, geopolygon, geobounds } = qs;
      //       let zoom = defaultZoom;
      //       if (geocircle) {
      //         zoom = geocircle.zoom || defaultZoom;
      //       } else if (geopolygon) {
      //         zoom = geopolygon.zoom || defaultZoom;
      //       } else if (geobounds) {
      //         zoom = geobounds.zoom || defaultZoom;
      //       }
      //       if(zoom){
      //         qs.precision = PRECISION_FROM_ZOOM_CONF[zoom] || maxLevel;
      //       }
      //     }
      //   }
      //   if ('includeSurrounding' in qs) { qs.includeSurrounding = false; }
      //   if ('surrounding' in qs) { qs.surrounding = false; }
      //   delete qs.page;
      //   delete qs.sortType;
      //   delete qs.activeSort;
      // }

      if ('misc' in qs && (qs.misc === 'undefined' || qs.misc === undefined)) {
        delete qs.misc;
      }

      if ('isRoomsNumber' in qs) {
        delete qs.isRoomsNumber;
      }

      if (qs.heating) {
        if (Array.isArray(qs.heating)) {
          qs.heating = qs.heating.join(',');
        }

        qs.heatingType = qs.heating;
        delete qs.heating;
      }

      if (isMap) {
        delete qs.zone;
        delete qs.zones;
      } else {
        if (qs.zone && qs.zones) {
          delete qs.zone;
        }
      }

      if (params.propertyTypeGroup === 'residenziale') {
        qs.propertyTypeGroup = 'case';
      } else if (params.propertyTypeGroup === 'vacanze') {
        qs.propertyTypeGroup = 'case-vacanza';
      }

      if (typeof params.propertyTypeGroup === 'undefined') {
        delete qs.propertyTypeGroup;
      }

      delete qs.category;
      var url = "/srp/".concat(isMap ? 'map/' : '').concat(this.getQS(qs));
      return url;
    }
  }, {
    key: "encodePdpUrl",
    value: function encodePdpUrl(params) {
      if ('propertyType' in params && 'region' in params && 'province' in params) {
        return (0, _utils.normalizeURL)("/immobile-".concat(params.propertyType, "-").concat(params.region, "-").concat(params.province, "-").concat(params.listingId));
      } else if ('listingId' in params) {
        return "/".concat(params.listingId);
      } else {
        return '';
      }
    }
  }, {
    key: "finalUrlToLangUrl",
    value: function finalUrlToLangUrl(final_url) {
      var def_lang = _SeoManagerHelpers.WEBSITE_DEFAULT_LANG[this.domain];

      if (this.lang === def_lang) {
        return final_url;
      } else {
        final_url = "/".concat(this.lang).concat(final_url);
      }

      return final_url;
    }
  }, {
    key: "getQS",
    value: function getQS(qs) {
      var qsKeys = Object.keys(qs);

      var splitObject = function splitObject(obj) {
        var res = '';

        if (obj) {
          Object.keys(obj).map(function (key) {
            res += "".concat([key], "=").concat(obj[key], "&");
          });
        }
      };

      var checkJSONParams = function checkJSONParams(key, obj) {
        if (obj && _typeof(obj) === 'object') {
          switch (key) {
            case 'nearby':
            case 'poi':
            case 'geopolygon':
            case 'geobounds':
            case 'geocircle':
              return true;

            default:
              return false;
          }
        }
      };

      var checkDefaultValue = function checkDefaultValue(val) {
        if (Array.isArray(val)) {
          val = val[0];
        }

        return ['all', 'any', 'qualsiasi'].includes(val);
      };

      var obj = qsKeys.map(function (el) {
        return checkJSONParams(el, qs[el]) ? "".concat(el, "=").concat(JSON.stringify(qs[el])) : !(ENCODE_EXCLUDE_PARAMS.indexOf(el) > -1) && !checkDefaultValue(qs[el]) ? _typeof(qs[el]) === 'object' && !Array.isArray(qs[el]) ? splitObject(el, qs[el]) : "".concat([el], "=").concat(Array.isArray(qs[el]) ? qs[el].join(',') : qs[el]) : null;
      }).filter(Boolean);
      return "".concat(obj.length ? "?".concat(obj.join('&')) : '');
    }
  }, {
    key: "clearSurroundingsParam",
    value: function clearSurroundingsParam(params) {
      if ('locations' in params && Array.isArray(params.locations) && params.locations.length === 1 && params.locations[0].level === 10) {
        if ('includeSurrounding' in params) {
          params.includeSurrounding = false;
        }

        if ('surrounding' in params) {
          params.surrounding = false;
        }

        if (!('includeSurrounding' in params) && !('surrounding' in params)) {
          params.surrounding = false;
        }
      }
    }
  }]);

  return BaseSeoManagerEncoder;
}();

var _default = BaseSeoManagerEncoder;
exports["default"] = _default;